/* HT medicion (29-sep-2026): la tienda no carga gtag en la pagina y los scripts de WhatsApp del theme lo necesitan.
   Se carga aqui solo para eventos, sin page_view. generate_lead lo dispara el script general de WhatsApp de layout/theme.liquid;
   aqui solo se agrega el detalle del carrito (evento whatsapp_carrito). */
(function () {
  var GA_ID = 'G-3SRB9819CK';
  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false });
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.js-btn-whatsapp-cart') : null;
    if (!a) { return; }
    var datos = {
      lead_source: 'whatsapp_carrito',
      page_path: window.location.pathname,
      items: parseInt(a.getAttribute('data-cart-items') || '0', 10),
      value: parseFloat(a.getAttribute('data-cart-value') || '0'),
      currency: 'USD'
    };
    try { window.gtag('event', 'whatsapp_carrito', datos); } catch (err) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { Shopify.analytics.publish('ht_whatsapp_click', datos); } } catch (err) {}
  }, true);
})();
